var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundLoginSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3836,
    height: 2160,
    viewBox: "0 0 3836 2160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7537_98516)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7537_98516",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 688,
    width: 3840,
    height: 1473
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3840 688H0V2160.48H3840V688Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7537_98516)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2996.16 2811.21C2996.16 2811.21 3183.52 2781.23 3280.28 2574.25C3377.04 2367.29 3546.69 2571.16 3632 2466.91C3717.32 2362.69 3660.42 2258.32 3845.48 2156.07C4030.57 2053.81 4131.37 1904.21 4046.81 1811.31C3962.28 1718.39 3764.77 1741.18 3603.13 1855.49C3441.49 1969.8 3296.78 1847.9 3144.3 1852.37C2991.8 1856.84 2917.81 2000.48 2859.53 2144.3C2801.23 2288.11 2474.02 2065.62 2364.8 2361.34C2255.56 2657.09 2712.32 2890.26 2996.13 2811.19L2996.16 2811.21Z",
    fill: "url(#paint0_linear_7537_98516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3456.45 2211.43C3452.6 2207.8 3437.87 2193.89 3437.87 2193.89C3299.05 2061.57 3270.72 1847.23 3354.88 1677.9C3357.25 1671.38 3360.28 1665 3364.08 1658.84C3366.86 1654.35 3377.46 1637.1 3377.46 1637.1C3499.66 1440.73 3771.46 1377.34 3975.22 1495.84C3976.06 1496.29 3976.87 1496.74 3977.69 1497.22C3977.77 1497.27 3977.89 1497.3 3977.97 1497.36C3979.74 1498.31 3981.48 1499.29 3983.17 1500.28C3993.21 1506.24 4002.09 1513.79 4009.45 1522.62C4028.51 1545.27 4037.76 1575.89 4032.14 1607.31C4022.1 1663.51 3968.38 1700.91 3912.16 1690.88C3891.95 1687.28 3874.18 1678.04 3860.16 1665.05C3805.62 1636.53 3748.41 1628.61 3693.6 1642.1C3632.65 1657.07 3580.73 1697.09 3542.92 1758.57C3541.4 1761.07 3538.23 1765.82 3538.23 1765.82C3536.45 1768.69 3534.54 1771.47 3532.55 1774.08C3514.42 1809.29 3505.76 1846.92 3507.13 1885.55C3509.41 1948.24 3538.03 2007.23 3590.54 2056.71C3592.68 2058.7 3596.7 2062.78 3596.7 2062.78C3637.85 2101.58 3640.07 2166.04 3601.28 2207.18C3562.46 2248.32 3497.63 2250.23 3456.48 2211.43H3456.45Z",
    fill: "url(#paint1_linear_7537_98516)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-507.38 907.824C-118.545 868.653 218.059 1038.91 403.059 1221.59C682.542 1497.58 836.029 1346.21 1061.34 1390.49C1444.83 1465.86 1191.24 1814.71 1541.82 1900.5C1892.48 1986.32 2131.23 2184.59 2042.17 2370.67C1953.11 2556.77 1619.55 2659.78 1300.57 2544.52C981.589 2429.23 813.624 2632.58 565.374 2690.64C317.095 2748.66 124.589 2548.57 -42.673 2341.42C-209.963 2134.29 -698.706 2806.61 -950.555 2331.66C-1194.7 1871.28 -992.075 956.633 -507.352 907.824H-507.38Z",
    fill: "url(#paint2_linear_7537_98516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M187.952 993.022C263.318 776.092 503.642 659.591 724.765 732.819C945.888 806.047 1064.04 1041.3 988.673 1258.23C913.307 1475.16 672.956 1591.66 451.861 1518.43C230.737 1445.2 112.586 1209.95 187.952 993.022Z",
    fill: "url(#paint3_linear_7537_98516)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M772.61 1105.73C703.766 1190.14 577.771 1203.04 491.132 1134.5C404.521 1065.97 390.1 941.965 458.917 857.553C527.761 773.142 653.756 760.244 740.395 828.779C827.006 897.314 841.427 1021.32 772.61 1105.73Z",
    stroke: "url(#paint4_linear_7537_98516)",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1425.44 2043.53C1419.96 2053.28 1406.32 2057.92 1397.21 2062.5C1390.72 2065.78 1383.97 2068.26 1377.34 2071.1C1372.79 2073.06 1366.24 2074.47 1362.78 2075.93C1350.72 2081.07 1339.31 2062.67 1349.96 2052.86C1354.32 2048.87 1360.08 2046.76 1365.98 2047.01C1371.75 2045.83 1377.45 2044.32 1383.05 2042.52C1394.63 2039.65 1407.14 2038.16 1418.52 2034.43C1421.78 2033.47 1425.19 2035.35 1426.11 2038.58C1426.59 2040.24 1426.34 2042.04 1425.44 2043.53Z",
    fill: "#ADE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.59 2135.11L1295.99 2136.17C1296.97 2140.14 1295.93 2144.35 1293.2 2147.39C1285.98 2153.03 1277.91 2157.53 1269.28 2160.71C1261.58 2164.56 1253.23 2167.14 1245.72 2171.38C1229.87 2180.38 1217.56 2158.82 1232.37 2147.08C1243.45 2140.84 1255.34 2136.2 1267.71 2133.31C1275.91 2130.11 1291.49 2123.47 1295.54 2135.08H1295.59V2135.11Z",
    fill: "#ADE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1623.17 2177.09C1615.47 2175.06 1608.02 2172.23 1600.94 2168.6C1594.78 2165.59 1588.12 2164.81 1582.13 2161.86C1576.34 2157.81 1574.96 2149.83 1579.01 2144.04C1580.47 2141.96 1582.5 2140.39 1584.86 2139.46C1595.31 2135.92 1602.88 2142.86 1609.62 2149.94C1615.72 2156.38 1625.11 2162.5 1628.18 2171.3C1628.8 2173.8 1627.28 2176.36 1624.78 2176.98C1624.24 2177.12 1623.71 2177.14 1623.14 2177.09H1623.17Z",
    fill: "#ADE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1695.42 2112.57C1687.41 2112.63 1679.45 2111.56 1671.75 2109.4C1662.78 2106.53 1654.07 2102.79 1645.24 2099.5C1626.77 2092.62 1642.63 2059.32 1661.01 2068.4C1669.33 2072.5 1677.09 2077.11 1685.24 2081.44C1692.47 2085.26 1701.1 2085.26 1705.26 2093.63C1708.77 2100.63 1704.36 2112.8 1695.39 2112.51H1695.45L1695.42 2112.57Z",
    fill: "#ADE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1557 2061.71C1549.55 2061.96 1542.07 2063.79 1534.54 2063.59C1526.98 2062.55 1519.36 2062.24 1511.74 2062.67C1492.57 2066.04 1492.09 2031.81 1511.74 2030.15C1516.24 2029.99 1520.74 2030.52 1525.06 2031.7C1530.18 2032.74 1535.49 2032.77 1540.55 2033.95C1550.11 2034.31 1559.02 2038.89 1564.87 2046.45C1567.51 2051.68 1565.43 2058.06 1560.2 2060.7C1559.19 2061.2 1558.12 2061.54 1557.03 2061.71H1557Z",
    fill: "#ADE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.91 2182.6C1484.89 2182.57 1480.9 2183.1 1477.02 2184.17C1472.67 2184.39 1468.28 2184.34 1463.92 2184C1454.39 2183.8 1444.83 2186.84 1435.39 2186.73C1420.1 2186.56 1420.21 2164.02 1435.45 2161.18C1447.53 2159.5 1459.82 2160.17 1471.62 2163.21C1479.83 2165.03 1492.74 2165.09 1495.74 2174.64C1496.59 2178.07 1494.51 2181.56 1491.08 2182.43C1490.38 2182.6 1489.64 2182.65 1488.91 2182.6Z",
    fill: "#ADE5FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1176.29 1851.69C1183.74 1829.3 1171.59 1805.13 1149.16 1797.77C1060.1 1768.55 879.264 1708.72 844.238 1697.09C827.399 1691.5 818.628 1688.46 804.32 1685.88C781.999 1681.86 764.851 1692.45 757.936 1713.08C751.358 1732.86 758.386 1750.17 777.22 1760.57C787.228 1766.1 798.079 1770.85 809.492 1774.7C848.567 1787.91 1051.84 1855.32 1051.84 1855.32C1075.37 1863.13 1098.87 1870.97 1122.4 1878.75C1144.75 1886.14 1168.89 1874 1176.32 1851.67L1176.29 1851.69Z",
    fill: "url(#paint5_linear_7537_98516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.364 1991.74C921.769 1999.19 945.944 1987.05 953.309 1964.63C982.545 1875.61 1042.39 1694.84 1054.03 1659.83C1059.63 1643 1062.66 1634.23 1065.25 1619.93C1069.27 1597.62 1058.67 1580.47 1038.04 1573.56C1018.25 1566.99 1000.93 1574.01 990.529 1592.84C984.991 1602.84 980.24 1613.69 976.389 1625.1C963.176 1664.16 895.738 1867.34 895.738 1867.34C887.923 1890.86 880.08 1914.36 872.293 1937.87C864.899 1960.21 877.044 1984.35 899.392 1991.77L899.364 1991.74Z",
    fill: "url(#paint6_linear_7537_98516)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-218.903 2094.56C-218.903 2094.56 -122.678 2241.38 88.7753 2244.72C300.228 2248.1 192.197 2468.43 312.513 2500.99C432.829 2533.56 499.481 2446.06 655.864 2563.57C812.275 2681.11 976.782 2709.58 1023.28 2603.08C1069.77 2496.58 975.798 2338.49 818.094 2245.31C660.362 2152.11 708.573 1983.87 647.121 1856.84C610.577 1781.36 535.998 1745.31 456.302 1732.92C421.697 1727.52 386.614 1726.9 351.672 1726.9C318.557 1726.9 284.261 1725.64 251.315 1714.59C93.7791 1661.71 155.596 1489.18 50.1785 1414.46C14.0274 1388.83 -34.071 1388.5 -77.784 1391.48C-368.932 1411.17 -393.108 1884.94 -218.931 2094.56H-218.903Z",
    fill: "url(#paint7_linear_7537_98516)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1187 1985.19C47.283 1985.08 55.5477 1990.79 63.8124 1993.6C68.7038 1995.25 73.5389 1997.02 78.2897 1998.99C80.4262 1999.86 82.6188 2000.71 84.6991 2001.69C84.418 2001.55 92.4297 2004.81 88.4379 2004.56C105.501 2005.6 101.65 2028.58 84.6429 2026.19C80.7073 2025.35 77.0247 2023.61 73.9043 2021.11C68.9568 2018.13 63.8124 2015.49 58.5275 2013.18C53.5799 2010.91 48.1263 2009.19 43.3755 2006.58C40.1427 2004.25 36.7975 2002.08 33.3398 2000.12C25.6935 1996.94 29.8259 1985.28 38.1187 1985.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46127 2060.22L8.88294 2059.41C10.6258 2056.71 13.6056 2055.05 16.8103 2054.97C23.9225 2056.06 30.8378 2058.28 37.2753 2061.51C43.6285 2063.87 49.5881 2067.25 56.0537 2069.27C69.7157 2073.51 63.981 2092.14 49.3069 2089.98C39.7772 2087 30.7254 2082.67 22.4326 2077.14C16.1919 2074.16 4.01969 2068.82 8.48938 2060.25L8.46127 2060.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.796 2004.75C176.848 2000.93 188.121 2007.45 196.245 2010.26C204.931 2012.2 213.168 2015.71 220.589 2020.63C229.922 2028.33 214.489 2042.74 205.943 2034.31C200.433 2030.32 194.277 2027.32 187.727 2025.46C180.531 2022.26 172.856 2018.75 166.053 2014.98C161.331 2012.4 163.073 2006.78 167.796 2004.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.581 1930.6C223.288 1936.72 235.6 1943.66 247.407 1951.36C251.399 1953.95 252.523 1959.29 249.937 1963.25C249.74 1963.56 249.487 1963.87 249.234 1964.18C245.777 1968.34 239.845 1969.43 235.151 1966.79C229.275 1963.22 223.653 1959.26 218.34 1954.88C212.099 1951.5 206.308 1947.34 201.108 1942.48C198.69 1938.77 199.759 1933.8 203.469 1931.41C205.578 1930.04 208.192 1929.75 210.553 1930.6H210.581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.447 1820.14C178.394 1831.97 191.213 1843.07 202.907 1854.98C214.404 1866.7 192.168 1882.94 183.285 1869.42C180.811 1865.66 177.775 1862.6 175.583 1858.61C172.968 1854.03 169.96 1849.64 166.643 1845.54C161.668 1839.16 153.965 1831.77 155.961 1823.06C157.282 1819.58 161.162 1817.83 164.647 1819.13C165.294 1819.38 165.912 1819.72 166.447 1820.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0787 1803.95C44.8937 1806.12 51.8371 1810.67 56.9253 1817.02C62.7443 1822.08 67.8606 1827.89 72.1335 1834.3C78.0931 1846.24 55.6603 1855.68 50.8532 1843.23C46.2149 1831.15 27.9988 1824.04 29.0389 1809.82C29.8541 1806.14 33.3118 1803.64 37.0506 1803.98L37.0787 1803.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.865 2089.33C171.254 2088.35 180.587 2087.25 190.116 2086.61C201.164 2085.88 212.381 2082 221.095 2088.88C223.85 2091.52 223.962 2095.88 221.32 2098.63C221.151 2098.8 220.983 2098.97 220.786 2099.11C211.256 2107.09 197.032 2104.39 185.45 2103.55C176.286 2104.14 167.065 2103.13 158.266 2100.52C152.56 2097.62 155.652 2089.95 161.836 2089.3L161.865 2089.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.911 1778.77C101.763 1778.75 98.7828 1777.45 96.5621 1775.23C92.2329 1771.95 87.7351 1768.88 83.5747 1765.46C77.1934 1759.89 71.4025 1753.71 66.2581 1747.02C59.9331 1739.27 72.5831 1729.54 80.6792 1733.48C83.8277 1735.11 86.2171 1737.92 87.3134 1741.29C89.6186 1745.34 92.4016 1749.07 95.6063 1752.47C101.988 1757.95 106.907 1764.89 109.971 1772.73C110.477 1775.54 108.594 1778.24 105.783 1778.72C105.501 1778.77 105.22 1778.8 104.939 1778.8L104.911 1778.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3407 1731.54C7.64607 1727.6 4.49761 1722.13 3.42938 1716.11C0.871257 1707.18 -0.449973 1697.93 -0.449973 1688.63C-0.927864 1675.14 23.8944 1674.3 22.292 1687.7C20.9146 1696.67 20.3524 1705.74 20.5773 1714.82C20.8303 1719.6 21.7298 1727.16 17.0071 1730.81C15.7421 1731.96 13.8868 1732.27 12.3125 1731.54H12.3407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5718 1899.72C67.2983 1901.88 76.5469 1905.84 84.8397 1911.38C92.7109 1915.4 99.8512 1920.65 106.036 1926.94C112.979 1936.55 95.1285 1946.7 88.3536 1937C87.3979 1935.65 83.8839 1934.36 82.394 1933.35C77.8962 1930.29 73.6233 1926.97 69.1255 1923.91C62.5475 1919.44 52.9334 1916.94 48.9979 1909.94C47.3393 1906.18 49.026 1901.79 52.7929 1900.14C54.2828 1899.46 55.9694 1899.32 57.5718 1899.72Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1582.69 1797.1C1510 1802.29 1445.9 1746.85 1439.58 1673.26",
    stroke: "#33C1FF",
    strokeWidth: 27,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7537_98516",
    x1: 2348.28,
    y1: 2290.25,
    x2: 4077.09,
    y2: 2290.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#33C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ADE5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7537_98516",
    x1: 3834.06,
    y1: 1054.6,
    x2: 3493.21,
    y2: 2429.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#33C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ADE5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7537_98516",
    x1: 1049.5,
    y1: 1355.53,
    x2: 606.16,
    y2: 1744.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7537_98516",
    x1: 243.393,
    y1: 1309.7,
    x2: 518.052,
    y2: 1162.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7537_98516",
    x1: 681.952,
    y1: 1176.82,
    x2: 549.491,
    y2: 785.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#9ADFFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7BD6FF",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#61CEFF",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4DC8FF",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3EC4FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#36C1FF",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33C1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7537_98516",
    x1: 1171.4,
    y1: 2028.2,
    x2: 984.191,
    y2: 1801.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB03B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7537_98516",
    x1: 1171.95,
    y1: 2027.75,
    x2: 984.712,
    y2: 1801.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB03B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7537_98516",
    x1: -285.732,
    y1: 1646.36,
    x2: 1613.99,
    y2: 2923.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FFC933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFC933",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7537_98516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3840,
    height: 2160,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLoginSvg);
export default __webpack_public_path__ + "static/media/backgroundLoginSvg.bd350970096bad3577616ec4ae58cd85.svg";
export { ForwardRef as ReactComponent };